import React from "react";

export default function HustleLogo({ size = 55 }: { size?: number }) {
  // Color palette inspired by input and modern finance brands
  const blue = "#53B7FC"; // new light blue
  const teal = "#36B37E";
  const dark = "#23272F";
  return (
    <div className="flex items-center gap-4 select-none">
      {/* Bar chart/arrow box */}
      <svg width={size} height={size} viewBox="0 0 55 55" fill="none" aria-hidden>
        <rect x="2" y="2" width="51" height="51" rx="10" fill={blue}/>
        {/* Four progressive bars: clean, all white, spaced like || || for HH hint */}
        <rect x="10" y="36" width="6" height="8" rx="2" fill="#fff"/>
        <rect x="20" y="28" width="6" height="16" rx="2" fill="#fff"/>
        <rect x="30" y="17" width="6" height="27" rx="2" fill="#fff"/>
        <rect x="40" y="7" width="6" height="37" rx="2" fill="#fff"/>
        {/* Up arrow for the tallest bar */}
        <polygon points="43,2 46,8 40,8" fill={teal}/>
      </svg>
      {/* Stacked text, "Hustle" with arrow-t, as a crossbar 't' */}
      <div className="font-bold" style={{lineHeight:1.05}}>
        <span style={{
          display:'block',
          fontSize: size*0.38,
          letterSpacing: '0.01em',
          color: dark,
          fontFamily: 'Poppins, Inter, sans-serif',
          fontWeight: 800
        }}>
          Hus
          <span style={{position:'relative',display:'inline-block',width: size*0.19,verticalAlign:'middle',height:size*0.41}}>
            <svg width={size*0.19} height={size*0.41} viewBox="0 0 22 44" style={{display:'block'}}>
              {/* Main vertical arrow/t: much thicker, fully embodies the "t" */}
              <rect x="8" y="9" width="6" height="27" rx="2.5" fill={teal}/>
              {/* Arrowhead, bold */}
              <polygon points="11,2 2,14 20,14" fill={teal}/>
              {/* Crossbar: wider and thicker for clarity */}
              <rect x="3" y="18" width="16" height="5" rx="2.2" fill={teal}/>
            </svg>
          </span>
          le
        </span>
        <span style={{
          display:'block',
          fontSize: size*0.33,
          letterSpacing: '0.01em',
          marginTop: -2,
          color: blue,
          fontFamily: 'Poppins, Inter, sans-serif',
          fontWeight: 800
        }}>
          Helper
        </span>
      </div>
    </div>
  )
}